import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRoleContent, IRolesAndPermissionsState } from '../../types/store';

const initialState: IRolesAndPermissionsState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const rolesAndPermissionsSlice = createSlice({
  name: 'rolesAndPermissionsSlice',
  initialState,
  reducers: {
    setRolesAndPermissions: (state, action) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    addNewRole: (state, action: PayloadAction<IRoleContent>) => {
      state.content.push(action.payload);
      state.page.totalElements++;
    },
    updateRole: (state, action: PayloadAction<IRoleContent>) => {
      const index = state.content.findIndex((x: IRoleContent) => x.id == action.payload.id);
      if (index > -1) {
        state.content[index] = action.payload;
      }
    },
    deleteRole: (state, action: PayloadAction<number>) => {
      state.content = state.content.filter((x: IRoleContent) => x.id !== action.payload);
      state.page.totalElements--;
    },
  },
});

export const { setRolesAndPermissions, addNewRole, updateRole, deleteRole } =
  rolesAndPermissionsSlice.actions;

export default rolesAndPermissionsSlice.reducer;
